import Spinner from "@/components/Spinner";
import { Button } from "@/components/ui/button";
import { useRef, useState } from "react";
import { useAppDispatch } from "../../../../store/hooks";
import { pushModal } from "../../../../store/slices/modalsSlice";
import { invokeUserRefetch } from "../../../../store/slices/storeSlice";
import GeneralMessageModal from "../../../Modals/GeneralMessageModal";
import { addNewBankCategory } from "../utils";

const AddNewBankCategory = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [resMsg, setResMsg] = useState(false);
  const newCatRef = useRef(null);
  const dispatch = useAppDispatch();

  const errorFn = () => {
    dispatch(pushModal(<GeneralMessageModal msg="حدث خطأ" btnMsg="حسنا" />));
  };

  return (
    <div className="p-3 space-y-6 flex flex-col">
      <h4
        style={{ textAlign: "center" }}
        className="mt-3 mb-4 bg-primary py-2 px-3 text-white rounded-ea shadow fw-bold"
      >
        إضافة مجموعة جديد لبنك الأسئلة
      </h4>
      <div className="flex flex-col gap-2">
        <label htmlFor="new_bank_cat_input">أكتب إسم المجموعة</label>
        <input
          ref={newCatRef}
          id="new_bank_cat_input"
          type="text"
          className="rounded-lg border border-gray-400 p-2 focus:ring-(--primary-color-light) w-full md:w-[30%] md:min-w-fit"
          required
        />
      </div>
      <Button
        disabled={isLoading}
        className="w-fit min-w-[30%]"
        onClick={async () => {
          await addNewBankCategory({
            newCat: newCatRef.current.value,
            setIsLoading,
            setResMsg,
            errorFn,
          });
          dispatch(invokeUserRefetch());
        }}
      >
        {isLoading ? <Spinner variant="button" /> : "إضافة المجموعة"}
      </Button>
      {resMsg && (
        <div
          style={{ display: "inline-block" }}
          className={`w-fit py-1 px-4 border ${
            resMsg.status
              ? "bg-green-100 text-green-700 border-green-400"
              : "bg-red-100 text-red-700 border-red-400"
          } rounded-lg`}
        >
          {resMsg.msg}
        </div>
      )}
    </div>
  );
};

export default AddNewBankCategory;
